
namespace Serenity.EmailClient {

    function flattenFolders(inside?: EmailFolder[]): EmailFolder[] {
        var result = [];
        inside = Q.coalesce(inside, []);
        for (var k of inside) {
            result.push(k);
            if (k.SubFolders && k.SubFolders.length) {
                for (var z of flattenFolders(k.SubFolders))
                    result.push(z);
            }
        }
        return result;
    }

    function findFolder(fullName: string, inside: EmailFolder[]): EmailFolder {
        inside = inside || [];
        for (var k of inside) {
            if (k.FullName == fullName)
                return k;

            if (k.SubFolders && k.SubFolders.length) {
                var sub = findFolder(fullName, k.SubFolders);
                if (sub)
                    return sub;
            }
        }

        return null;
    }

    interface FolderAndMsg {
        folder?: string;
        msg?: number;
    }

    function parseFolderAndMsg(hash: string): FolderAndMsg {
        if (!hash)
            return {};

        if (hash.charAt(0) == '#')
            hash = hash.substr(1);

        var result: FolderAndMsg = {};
        if (Q.startsWith(hash, 'folder/')) {
            var folder = hash.substr('folder/'.length);
            var idx = folder.lastIndexOf('/');
            result.msg = -1;
            if (idx < folder.length - 1) {
                result.msg = parseInt(folder.substr(idx + 1), 10);
                if (isNaN(result.msg)) {
                    result.msg = -1;
                }
                else {
                    folder = folder.substr(0, idx);
                }
            }

            result.folder = decodeURIComponent(folder);
        }

        return result;
    }

    function formatDate(date: any, format?: string) {
        return Q.formatDate(date, format || 'yyyy-MM-dd HH:mm');
    }

    export interface MailboxItem extends EmailItem {
        __checked?: boolean;
    }

    export interface MailboxState {
        showLogin: boolean;
        folder: string;
        folders: any[];
        messageCount: number;
        messages: MailboxItem[];
        page: number;
        pageSize: number;
        viewingMessage: number;
        newMessages: number,
        containsText: string,
        containsLock: 0
    }

    export class MailboxView extends React.Component<{}, MailboxState> {

        private reloadTimeout: number = 0;
        private element: HTMLElement;

        constructor(props: {}, context?: any) {
            super(props, context);

            this.state = {
                folder: "",
                folders: [],
                viewingMessage: -1,
                newMessages: 0,
                messages: [],
                messageCount: 0,
                page: 0,
                pageSize: 20,
                containsText: "",
                containsLock: 0,
                showLogin: false
            };
        }

        private loadMessages() {
            EmailService.ListMessages({
                Folder: this.state.folder,
                Skip: this.state.page * this.state.pageSize,
                Take: this.state.pageSize,
                ContainsText: this.state.containsText
            },
                respmsg => {
                    this.setState({
                        messages: (respmsg.Entities || []),
                        messageCount: respmsg.TotalCount || 0
                    });
                },
                {
                    onError: (response: ServiceResponse) => this.serviceErrorHandler(response)
                }
            );
        }

        composeMessage() {
            new EmailComposeDialog().dialogOpen();
        }

        serviceErrorHandler(response: ServiceResponse) {
            if (response.Error && response.Error.Code == "UnauthorizedAccess") {
                this.setState({
                    showLogin: true
                })
            }
            else {
                Q.ErrorHandling.showServiceError(response.Error);
            }
        }

        initialLoadFolders() {
            EmailService.ListFolders({
            }, response => {
                for (var folder of response.Entities || []) {
                    if (folder.FullName == "INBOX")
                        $('#UnreadEmailCount').text(folder.UnreadCount || 0).toggle(folder.UnreadCount > 0);
                }

                var folderName: string;
                if (window.location.hash && Q.startsWith(window.location.hash, "#folder/"))
                    folderName = parseFolderAndMsg(window.location.hash).folder
                else
                    folderName = this.state.folder || (this.state.folders[0] || {}).FullName || "INBOX";

                if (this.state.folder !== folderName) {
                    this.setState({
                        folders: response.Entities || [],
                        folder: folderName
                    }, () => this.loadMessages());
                }
                else {
                    this.setState({
                        folders: response.Entities || [],
                    });
                }
            },
                {
                    onError: (response: ServiceResponse) => this.serviceErrorHandler(response)
                });
        }

        changeFolder(folder: string) {
            this.setState({
                folder: folder,
                page: 0,
                containsText: ""
            }, () => this.loadMessages());
        }

        changePage(page: number) {
            if (page < 0)
                page = 0;
            var maxPage = Math.floor(Math.max(this.state.messageCount - 1, 0) / (this.state.pageSize || 20));
            if (page > maxPage)
                page = maxPage;
            if (this.state.page != page) {
                this.setState({
                    page: page
                }, () => this.loadMessages());
            }
        }

        setElement(el: HTMLElement) {
            if (this.element) 
                $(this.element.parentElement).removeClass('route-handler').off('handleroute');

            this.element = el;

            if (this.element) {
                $(this.element).addClass("route-handler")
                    .on("handleroute", (e, args) => {
                        var route: string = args.route || '';
                        if (Q.startsWith(route, 'folder/')) {
                            args.handled = true;
                            var parsed = parseFolderAndMsg(route);
                            var msg = parsed.msg;
                            var folder = parsed.folder;

                            if (this.state.folder != folder) {
                                this.setState({
                                    viewingMessage: -1
                                }, () => this.changeFolder(folder));
                            }

                            if (this.state.viewingMessage != msg) {
                                this.setState({
                                    viewingMessage: msg
                                });

                                if (msg >= 0) {
                                    var message = Q.tryFirst<any>(this.state.messages || [], x => x.UniqueId == msg);
                                    if (message && !message.Seen) {
                                        this.toggleSeen(message);
                                    }
                                }
                            }
                        }
                    });
            }
        }

        componentDidMount() {
            this.initialLoadFolders();
            Q.Router.resolve();
        }

        activeFolderName(): string {
            if (!this.state.folder)
                return "";

            var folder = findFolder(this.state.folder, this.state.folders);
            if (!folder)
                return "";

            return mailboxFolderName(folder);
        }

        setContainsText(newValue: string) {
            if (newValue === this.state.containsText)
                return;

            this.setState({
                containsText: newValue
            });

            clearTimeout(this.reloadTimeout);
            this.reloadTimeout = window.setTimeout(() => {
                this.setState({
                    page: 0
                }, () => this.loadMessages());
            }, 500);
        }

        allChecked() {
            return this.state.messages.length && !Q.any(this.state.messages, x => !x.__checked);
        }

        checkAll() {
            var allChecked = this.allChecked();
            this.setState({
                messages: this.state.messages.map(x => $.extend({}, x, { __checked: !allChecked }))
            });
        }

        deleteSelected() {
            var selectedIds = this.state.messages.filter(x => x.__checked).map(x => x.UniqueId);
            if (!selectedIds.length) {
                Q.notifyWarning(Q.text("Site.EmailClient.DeleteNoSelectionWarning"));
                return;
            }

            Q.confirm(Q.format(Q.text("Site.EmailClient.DeleteSelectedConfirmation"), selectedIds.length), () => {
                EmailService.DeleteMessages({
                    Folder: this.state.folder,
                    UniqueIds: selectedIds
                }, response => {
                    Q.notifyInfo(Q.text("Site.EmailClient.DeleteSelectedSuccess"));
                    this.loadMessages();
                });
            });
        }

        moveToFolder(folder: string, message?: MailboxItem) {
            if (!folder)
                return;

            var selected = message ? [message] : this.state.messages.filter(x => x.__checked);
            if (!selected.length) {
                Q.notifyWarning(Q.text("Site.EmailClient.MoveNoSelectionWarning"));
                return;
            }

            EmailService.Move({
                SourceFolder: this.state.folder,
                UniqueIds: selected.map(x => x.UniqueId),
                TargetFolder: folder
            }, response => {
                Q.notifySuccess(Q.format(Q.text("Site.EmailClient.MoveSelectedSuccess"), selected.length));
                this.loadMessages();
            });
        }

        getToolbarProps(): MailboxToolbarProps {
            return {
                allChecked: this.allChecked(),
                flatFolderList: flattenFolders(this.state.folders),
                folder: this.state.folder,
                messageCount: this.state.messageCount,
                onChangePage: (page) => this.changePage(page),
                onCheckAll: () => this.checkAll(),
                onDelete: () => this.deleteSelected(),
                onMoveToFolder: (target) => this.moveToFolder(target),
                onRefresh: () => this.refreshMessages(),
                onToggleSeen: () => { this.toggleSeen() },
                page: this.state.page,
                pageSize: this.state.pageSize
            };
        }

        setChecked(message: MailboxItem, value: boolean) {
            if (!!message.__checked !== !!value) {
                this.setState({
                    messages: this.state.messages.map(x => x === message ? $.extend({}, x, { __checked: !!value }) : x)
                });
            }
        }

        toggleSeen(message?: MailboxItem) {
            var selected = message ? [message] : this.state.messages.filter(x => x.__checked);
            if (!selected.length) {
                Q.notifyWarning(Q.text("Site.EmailClient.ToggleSeenNoSelectionWarning"));
                return;
            }

            var seen = Q.any<any>(selected, x => !x.Seen);
            EmailService.ToggleSeen({
                Folder: this.state.folder,
                UniqueIds: selected.map(x => x.UniqueId),
                Seen: seen
            }, response => {
                var folder = findFolder(this.state.folder, this.state.folders);
                var unreadCount = folder ? (folder.UnreadCount || 0) : 0;
                var messages = this.state.messages.map(x => {
                    if (selected.indexOf(x) < 0 || seen == !!x.Seen)
                        return x;

                    if (folder) {
                        unreadCount = Math.max(unreadCount + (seen ? -1 : 1), 0);
                        if (folder.FullName == "INBOX")
                            $('#UnreadEmailCount').text(unreadCount).toggle(unreadCount > 0);
                    }

                    return $.extend({}, x, { Seen: seen })
                });

                var folders = this.state.folders.map(x => {
                    if (x !== folder)
                        return x;

                    return $.extend({}, x, { UnreadCount: unreadCount });
                });

                this.setState({
                    messages: messages,
                    folders: folders
                })
            });
        }

        refreshMessages() {
            this.loadMessages();
        }

        signout() {
            EmailService.Signout({}, response => this.setState({
                showLogin: true,
                folders: [],
                folder: ""
            }));
        }

        render() {

            if (this.state.showLogin)
                return <MailboxLoginView onLogin={() => this.setState({
                    showLogin: false,
                    folders: [],
                    folder: ""
                }, () => this.initialLoadFolders())} />

            var toolbarProps = this.getToolbarProps();
            return (
                <div ref={el => this.setElement(el)} className="s-MailboxView">
                    <div className="mailbox">
                        <div className="row">
                            <div className="col-md-3">
                                <a href="javascript:;" className="btn btn-primary btn-block margin-bottom"
                                    onClick={e => this.composeMessage()}>
                                    <i className="fa fa-envelope-o"></i> {Q.text("Site.EmailClient.ComposeButton")}
                                </a>

                                <div className="box box-solid">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">{Q.text("Site.EmailClient.FoldersTitle")}</h3>
                                    </div>
                                    <div className="box-body no-padding">
                                        {this.state.folders.map(fld =>
                                            <ul className="nav nav-pills nav-stacked" key={fld.FullName}>
                                                <MailboxFolderLink folder={fld} activeFolder={this.state.folder} />
                                            </ul>)
                                        }
                                    </div>
                                </div>

                                <div>
                                    <button className="btn btn-small btn-danger pull-right" onClick={e => this.signout()}>
                                        <i className="fa fa-sign-out"></i> {Q.text("Site.EmailClient.SignoutButton")}
                                    </button>
                                </div>
                            </div>
                            <div className="col-md-9">
                                {this.state.viewingMessage < 0 && <div className="box box-primary">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">{this.activeFolderName()}</h3>
                                        <div className="box-tools pull-right">
                                            <div className="has-feedback">
                                                <input type="text" className="form-control input-sm" placeholder={Q.text("Site.EmailClient.SearchPlaceholder")} value={this.state.containsText}
                                                    onChange={e => this.setContainsText(e.target.value)} />
                                                <span className="glyphicon glyphicon-search form-control-feedback"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-body no-padding">
                                        {React.createElement(MailboxToolbar, toolbarProps)}

                                        <div className="table-responsive mailbox-messages" style={{minHeight: "40px"}}>
                                            <table className="table table-hover table-striped mail-table">
                                                <tbody>
                                                {this.state.messages.map(message =>
                                                    <tr className={!message.Seen ? "unseen" : null} key={message.UniqueId}>
                                                        <td className="mailbox-check">
                                                            <input type="checkbox" checked={message.__checked} onClick={e => this.setChecked(message, (e.target as any).checked)} />
                                                        </td>
                                                        <td className="mailbox-star">
                                                            <a href="javascript:;" onClick={e => this.toggleSeen(message)}>
                                                                <i className={"fa" + (!message.Seen ? " fa-star": "") + (message.Seen ? " fa-star-o": "") + ' text-yellow'}></i>
                                                            </a>
                                                        </td>
                                                        <td className="mailbox-name">
                                                            <div>
                                                                <a href={'#folder/' + encodeURIComponent(this.state.folder) + '/' + message.UniqueId}>
                                                                    {message.From}
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td className="mailbox-subject">
                                                            <div>{message.Subject}</div>
                                                        </td>
                                                        <td className="mailbox-attachment">
                                                            {!!message.HasAttachments && <i className="fa fa-paperclip"></i>}
                                                        </td>
                                                        <td className="mailbox-date">
                                                            <div>{formatDate(message.Date)}</div>
                                                        </td>
                                                    </tr>)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="box-footer no-padding">
                                        {React.createElement(MailboxToolbar, toolbarProps)}
                                    </div>
                                </div>}
                                {this.state.viewingMessage >= 0 && <div className="box box-primary">
                                    <div className="box-body">
                                        <MailViewer folder={this.state.folder} uid={this.state.viewingMessage}
                                        onClose={() => this.refreshMessages()} flatFolderList={toolbarProps.flatFolderList} />
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}